import React, { useState, useEffect } from 'react';
import {  CalendarDaysIcon } from '@heroicons/react/24/outline';
import adminApi from '../../api/adminApi';

const AdminInterns = () => {
  const [interns, setInterns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInterns();
  }, []);

  const loadInterns = async () => {
    try {
      const data = await adminApi.getActiveInterns();
      setInterns(data);
    } catch (error) {
      console.error("Failed to fetch interns");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-white p-10">Loading interns...</div>;

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Internship Management</h2>
        <p className="text-gray-400 mt-2 text-sm">Tracking {interns.length} active winners.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {interns.map(intern => (
          <div key={intern.id} className="bg-gray-800 border border-gray-700 rounded-[2rem] p-6 shadow-xl relative group">
            {/* Identity */}
            <div className="flex justify-between items-start mb-6">
              <div className="flex items-center space-x-4">
                <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white font-bold text-xl shadow-lg">
                  {intern.full_name?.charAt(0)}
                </div>
                <div>
                  <h3 className="text-white font-bold text-lg leading-tight">{intern.full_name}</h3>
                  <div className="text-gray-500 text-xs truncate w-40">{intern.email}</div>
                </div>
              </div>
              <span className="bg-blue-500/10 text-blue-400 text-[10px] font-bold px-3 py-1 rounded-full border border-blue-500/20">
                {intern.duration_days} Days
              </span>
            </div>

            {/* Progress Bar */}
            <div className="mb-6">
              <div className="flex justify-between text-xs mb-2">
                <span className="text-gray-400 font-medium">Progress</span>
                <span className="text-blue-400 font-bold">{intern.progress_percent}%</span>
              </div>
              <div className="w-full bg-gray-900 h-2.5 rounded-full overflow-hidden border border-gray-700">
                <div 
                  className="bg-gradient-to-r from-green-500 to-blue-500 h-full rounded-full transition-all duration-1000"
                  style={{ width: `${intern.progress_percent}%` }}
                />
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-gray-900/50 p-3 rounded-2xl border border-gray-700/50">
                <p className="text-gray-500 text-[10px] uppercase font-bold tracking-wider mb-1">Days Left</p>
                <p className="text-white font-mono text-lg">{intern.duration_days - intern.days_completed}</p>
              </div>
              <div className="bg-gray-900/50 p-3 rounded-2xl border border-gray-700/50">
                <p className="text-gray-500 text-[10px] uppercase font-bold tracking-wider mb-1">Stipend</p>
                <p className="text-yellow-500 font-mono text-sm uppercase">{intern.stipend_status}</p>
              </div>
            </div>

            <button className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-2xl text-xs transition-all flex items-center justify-center">
              <CalendarDaysIcon className="h-4 w-4 mr-2" /> View Weekly Reports
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminInterns;